import "./BalanceSheet.css";
import * as React from "react";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import DateFilter from "./DateFilter.jsx";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect, useRef } from "react";
import ListPagination, { pickTotal } from "../../components/ListPagination/ListPagination";
import EditIcon from "@mui/icons-material/Edit";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import CancelIcon from '@mui/icons-material/Cancel';
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper } from "@mui/material";
import AppToast from '../../components/Toast/AppToast';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from '@mui/material';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Menu from '@mui/material/Menu';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import { Link } from 'react-router-dom';

import {
    UpdateFollowUP,
    createFollowup,
    retrieveFollwupVisitor,
    deleteFollowup,
    AutocompleteFollowup,
    StatusFollowup,
  } from "../Apihelper/FollowupApi";




import { useNavigate } from "react-router-dom";

const buildStyles = (appColors) => ({
  mainBox: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#EFEDF1'
  },
  contentBox: {
    flexGrow: 1,
    overflowY: 'auto',
    padding: { xs: '8px', sm: '16px' },
    marginTop: '64px'
  },
  pageTitle: {
    fontSize: { xs: '1.25rem', sm: '1.5rem' },
    fontWeight: 700,
    color: appColors.leaf,
    marginBottom: '4px'
  },
  addButton: {
    backgroundColor: appColors.leaf,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: appColors.pine,
    },
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 16px',
    boxShadow: '0 4px 6px -1px rgba(31, 122, 84, 0.1)',
  },
  tableContainer: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(31, 122, 84, 0.1)',
    overflowX: 'auto',
  },
  tableHead: {
    backgroundColor: appColors.leaf,
    '& th': {
      color: '#ffffff',
      fontWeight: 600,
      fontSize: { xs: '13px', sm: '14px', md: '15px' },
      padding: { xs: '12px 8px', sm: '16px' },
      whiteSpace: 'nowrap'
    }
  },
  tableCell: {
    padding: { xs: '8px', sm: '16px' },
    fontSize: { xs: '12px', sm: '14px' },
    color: '#1e293b',
    whiteSpace: 'nowrap'
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f8fafc',
    },
    '&:hover': {
      backgroundColor: 'rgba(31, 122, 84, 0.04)',
      transition: 'background-color 0.2s'
    }
  },
  statusButton: (status) => ({
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '20px',
    padding: '6px 16px',
    fontSize: { xs: '12px', sm: '13px' },
    backgroundColor: status === 1 ? '#22c55e' : '#ef4444',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: status === 1 ? '#16a34a' : '#dc2626',
    }
  }),
  actionButton: {
    padding: '8px',
    '& .MuiSvgIcon-root': {
      fontSize: { xs: '18px', sm: '20px' }
    }
  },
  loadMoreButton: {
    backgroundColor: appColors.leaf,
    color: '#ffffff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 24px',
    marginTop: '24px',
    '&:hover': {
      backgroundColor: appColors.pine,
    },
    '&.Mui-disabled': {
      backgroundColor: '#94a3b8',
      color: '#ffffff'
    }
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      '& fieldset': {
        borderColor: 'rgba(31, 122, 84, 0.2)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(31, 122, 84, 0.3)',
      },
      '&.Mui-focused fieldset': {
        borderColor: appColors.leaf,
      }
    }
  }
});

const drawerWidth = 292;

function FollowUP(props) {
  const { colors: appColors } = useAppTheme();
  const useStyles = buildStyles(appColors);
  const navigate = useNavigate();
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const { window1 } = props;
  const [field, setField] = useState("");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const filterRef = useRef({ search: '', datelist: '', from: '', to: '' });
  const [status, setstatus] = useState('');
  const [options, setOptions] = useState([]);
  const [fetchdatarow, setetchdatarow] = useState([]); 
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [datelist, setDatelist] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [todate, settodate] = useState("");
  const [field1, setField1] = useState("");
  const [field2, setField2] = useState("");
  const [field3, setField3] = React.useState(dayjs());
  const [field4, setField4] = React.useState(null); // Initialize as null or dayjs()
  
  const [editItem, setEditItem] = useState({});
const [modalMode, setModalMode] = useState("");
const [formSubmitted, setFormSubmitted] = useState(false);
const [addmodalopen, setaddmodalopen] = useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);

  const handleaddOpen = () => {
    setModalMode("add");
    setField1("");
    setField2("");
    setField3(dayjs());
    setField4(null);
    setFormSubmitted(false);
    setaddmodalopen(true);
  };
  const handleaddClose = () => {
    setField1("");
    setField2("");
    setField3("");
    setField4("");
    setFormSubmitted(false);
    setaddmodalopen(false);
  };
  const handleCancelDelete = () => {
    setOpenDeleteConfirmation(false);
  };
  const handleConfirmDelete = async (id) => {
    // setSnackbarMessage('package deleted successfully');
    // setSnackbarSeverity('error');
    // setOpenDeleteConfirmation(false);
    // setOpenToast(true); // Show toast message

    if (deleteConfirmationId !== null) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;

        const res = await deleteFollowup(
          userToken,
          userId,
          deleteConfirmationId
        );

        if (res.code == "200") {
          handleSnackbarOpen(res.message, "success");
          setOpenDeleteConfirmation(false);
          fetchData();
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handleSubmit = async () => {
    setFormSubmitted(true)
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    if (!field1 || !field2 || !field3 || !field4) {
     
      return; // Stop submission if validation fails
    }
    if (modalMode === "add") {
      try {
        const res = await createFollowup(
          userToken,
          field1,
          field2,
          field3,
          field4
        );
        if (res.code == "200") {
          setField1("");
          setField2("");
          setField3("");
          setField4("");

          handleSnackbarOpen(res.message, "success");
          fetchData();
        } else {
          handleSnackbarOpen(res.message, "error");
          //   console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error); // Handle error
      }
    } else if (modalMode === "edit") {
      try {
        if (editItem) {
          const { id, name, phone, visit_date, followup_date } =
            editItem;

          const res = await UpdateFollowUP(
            id,
            userToken,
            field1,
            field2,
            field3,
            field4
          );
          if (res.code == "200") {
            setField1("");
            setField2("");
            setField3("");
            setField4("");

            handleSnackbarOpen(res.message, "success");
            fetchData();
          } else {
            handleSnackbarOpen(res.message, "error");
            //   console.error(error); // Handle error
          }
        }
      } catch (error) {
        console.error(error); // Handle error
      }
    }

    // Close the modal after submission
    handleaddClose();
  };

  const handleConfirm = async() => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; 
     
      
        const res = await StatusFollowup(userToken,userId,status, deleteConfirmationId);

        if (res.code == "200") {
            handleSnackbarOpen(res.message, 'success');
            setIsActive(!isActive);
            setOpenConfirmation(false);
          //  setOpenDeleteConfirmation(false);
            fetchData();
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
 
 


 
 
  const open = Boolean(anchorEl);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };

  // One page of follow-ups for the current search / date filter. The filters live in a ref so
  // changing page or rows-per-page keeps them.
  const loadPage = async (pageZero = 0, size = rowsPerPage) => {
    setLoading(true);
    try {
      const userDataObj = JSON.parse(localStorage.getItem("userdata"));
      const f = filterRef.current;
      const res = await retrieveFollwupVisitor(
        userDataObj.token,
        userDataObj.id,
        f.search,
        size,
        pageZero * size,
        f.datelist,
        f.from,
        f.to
      );

      if (res.code == "200" && Array.isArray(res.data) && res.data.length > 0) {
        setetchdatarow(res.data);
        setPage(pageZero);
        const total = pickTotal(res);
        setTotalCount(total != null ? total : pageZero * size + res.data.length);
      } else if (pageZero > 0) {
        // The last row of the last page was just removed: step back one page.
        await loadPage(pageZero - 1, size);
        return;
      } else {
        setetchdatarow([]);
        setTotalCount(0);
        setPage(0);
      }
    } catch (error) {
      console.error(error);
      setetchdatarow([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  // Search (plain text, no date filter) — starts at page 0. No argument = refresh the current page.
  const fetchData = (value) => {
    if (value === undefined) return loadPage(page);
    filterRef.current = { search: value || '', datelist: '', from: '', to: '' };
    return loadPage(0);
  };

  const handleApplydatecustom = async ({ fromDateval, toDateval, value = '' }) => {
    settodate(toDateval);
    setFromDate(fromDateval);
    filterRef.current = { search: value, datelist: '', from: fromDateval, to: toDateval };
    await loadPage(0);
  };

  const handleApplydate = async (selectedValue, value = '') => {
    setDatelist(selectedValue);
    filterRef.current = { search: value, datelist: selectedValue, from: '', to: '' };
    await loadPage(0);
  };

  useEffect(() => {
    loadPage(0);
  }, []);

const handleSearchChange = (event, value) => {
  const searchText = value || ''; // If value is undefined or empty, set searchText to empty string
  // setSearchText(searchText);
  // Call fetchData function here with the updated searchText
  fetchData(searchText);
};


const handleInputChange = async (value) => {
  if (value.length >= 3) {
  try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
    
      const res = await AutocompleteFollowup(userToken, userId, searchText);

      if (res.code == "200") {
          const names = res.data.map(item => item.search_text);
          setOptions(names);
      } else {
          handleSnackbarOpen(res.message, 'error');
          //  console.error(error); // Handle error
      }
  } catch (error) {
      console.error(error);
      // Handle errors
  }
}
};


React.useEffect(() => {
  const storedData = localStorage.getItem("userdata");
  if (!storedData) {
    // User is not logged in, no need to redirect
    navigate('/');
  }
  
}, []);


//  modalMode
const handleEditModalOpen = (
  id,
  name,
  phone,
  visit_date,
  followup_date
) => {
  setModalMode("edit");
  setEditItem({
    id: id,
    name: name,
    phone: phone,
    visit_date: visit_date,
    followup_date: followup_date,
  });
  // console.log(admissionValue);
  setField(id);
  setField1(name || "");
  setField2(phone || "");
  console.log("visit_date:", visit_date);
  console.log("Parsed visit_date with dayjs:", dayjs(visit_date).format());

  setField3(visit_date ? dayjs(visit_date, "DD-MM-YYYY") : null); 

  setField4(followup_date ? dayjs(followup_date, "DD-MM-YYYY") : null); 
  setaddmodalopen(true); // Open the edit modal
};
const handleDelete = (id) => {
    handleClose();
    setDeleteConfirmationId(id);
    setOpenDeleteConfirmation(true, id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleToggle = (id, status) => {
    setOpenConfirmation(true);
    const newStatus = status === 1 ? 0 : 1;
    setstatus(newStatus);
    setDeleteConfirmationId(id);
    setIsActive(newStatus === 0);
  };

  
  return (
    <Box sx={useStyles.mainBox}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>
      <Box component="main" sx={useStyles.contentBox}>
        <Container maxWidth="xl" sx={{ px: { xs: '8px', sm: '16px' } }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography sx={useStyles.pageTitle}>
              Follow-up Visitors
            </Typography>
          <Button
            variant="contained"
            startIcon={<ControlPointIcon />}
            onClick={handleaddOpen}
              sx={useStyles.addButton}
          >
            Add New
          </Button>
        </Box>

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 3 }}>
            <Box sx={{ flex: { xs: '1', sm: '0 0 300px' } }}>
                <Autocomplete
                  freeSolo
                  id="free-solo-2-demo"
                  disableClearable
                  options={options}
                onInputChange={(event, value) => handleInputChange(value)}
                  onChange={(event, value) => handleSearchChange(event, value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search input"
                    size="small"
                      InputProps={{
                        ...params.InputProps,
                        type: 'search',
                      }}
                    sx={useStyles.searchField}
                  />
                )}
                />
              </Box>
              <Box>
              <FormControl>
                <DateFilter 
                  ref={dateRef}
                   onApplycustomdate={handleApplydatecustom}
                   onApply={handleApplydate}
                  Onreset={fetchData}
                  />
                </FormControl>
              </Box>
            </Box>

          <Box sx={useStyles.tableContainer}>
            <TableContainer>
              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                  <CircularProgress sx={{ color: appColors.leaf }} />
        </Box>
              ) : fetchdatarow.length === 0 ? (
                <Box sx={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                  py: 8, px: 2, backgroundColor: '#fafbfc', borderRadius: 1,
                }}>
                  <Typography variant="h6" sx={{ color: '#475569', fontWeight: 600 }}>
                    No follow-up visitors
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#94a3b8', mt: 1, textAlign: 'center', maxWidth: 320 }}>
                    No data found for the selected filter. Try a different date range or clear the filter.
                  </Typography>
                </Box>
              ) : (
                <Table sx={{ minWidth: { xs: 650, sm: 750, md: 900 } }} size="small">
          <TableHead>
                    <TableRow sx={useStyles.tableHead}>
                      <TableCell>#</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Followup Date</TableCell>
                      <TableCell>Visit Date</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
                    {fetchdatarow.map((row, index) => (
                      <TableRow key={row.id} sx={useStyles.tableRow}>
                        <TableCell sx={useStyles.tableCell}>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell sx={useStyles.tableCell}>{row.name}</TableCell>
                        <TableCell sx={useStyles.tableCell}>{row.phone}</TableCell>
                        <TableCell sx={useStyles.tableCell}>{row.followup_date}</TableCell>
                        <TableCell sx={useStyles.tableCell}>{row.visit_date}</TableCell>
                        <TableCell sx={useStyles.tableCell}>
                <Button
                  variant="contained"
                            sx={useStyles.statusButton(row.status)}
                  onClick={() => handleToggle(row.id, row.status)}
                >
                  {row.status === 1 ? "Followed" : "Pending"}
                </Button>
              </TableCell>
                        <TableCell sx={useStyles.tableCell}>
                  <IconButton
                            onClick={() => handleEditModalOpen(row.id, row.name, row.phone, row.visit_date, row.followup_date)}
                            sx={{ ...useStyles.actionButton, color: appColors.leaf }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDelete(row.id)}
                            sx={{ ...useStyles.actionButton, color: '#ef4444' }}
                  >
                    <DeleteIcon />
                  </IconButton>
              </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
          </Box>

          <ListPagination
            count={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(p) => loadPage(p)}
            onRowsPerPageChange={(size) => { setRowsPerPage(size); loadPage(0, size); }}
          />
        </Container>
      </Box>

      <Dialog
        open={addmodalopen}
        maxWidth="xs"
        fullWidth
        onClose={(event, reason) => { if (reason !== 'backdropClick') handleaddClose(); }}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            backgroundColor: '#ffffff',
            maxWidth: '320px',
            width: '100%'
          }
        }}
      >
        <DialogTitle sx={{
          color: appColors.leaf,
          fontSize: '0.95rem',
          fontWeight: 600,
          borderBottom: '1px solid rgba(31, 122, 84, 0.1)',
          padding: '10px 14px'
        }}>
          {modalMode === "add" ? "Add Visitor" : "Edit Visitor"}
  </DialogTitle>
        <DialogContent sx={{ padding: '12px 14px' }}>
    <TextField
      autoFocus
      margin="dense"
      label="Name"
      fullWidth
      type="text"
      value={field1}
      error={formSubmitted && !field1}
      helperText={formSubmitted && !field1 ? "Name is required" : ""}
      onChange={(e) => setField1(e.target.value.toUpperCase())}
      inputProps={{ style: { textTransform: 'uppercase' } }}
            sx={useStyles.searchField}
    />
    <TextField
      margin="dense"
      label="Phone"
      fullWidth
      type="number"
      error={formSubmitted && !field2}
      helperText={formSubmitted && !field2 ? "Phone is required" : ""}
      value={field2}
      inputProps={{ min: 0 }}
      onChange={(e) => setField2(Math.max(0, e.target.value))}
            sx={useStyles.searchField}
    />
<LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box display="flex" flexDirection="column" gap={1} mt={1}>
            <DatePicker
              value={field3 ? dayjs(field3) : null}
              onChange={(date) => setField3(date)}
              label="Visiting Date"
              format="DD/MM/YYYY"
              clearable
                sx={{ flex: 1 }}
                slotProps={{
                  textField: {
                    size: 'small',
                    sx: useStyles.searchField
                  }
                }}
            />
            <DatePicker
              value={field4 ? dayjs(field4) : null}
              onChange={(date) => setField4(date)}
              label="Follow up Date"
              format="DD/MM/YYYY"
              clearable
                sx={{ flex: 1 }}
                slotProps={{
                  textField: {
                    size: 'small',
                    sx: useStyles.searchField
                  }
                }}
            />
          </Box>
        </LocalizationProvider>
  </DialogContent>
        <DialogActions sx={{ padding: '10px 14px', borderTop: '1px solid rgba(31, 122, 84, 0.1)' }}>
    <Button
      onClick={handleaddClose}
            sx={{
              color: '#64748b',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(100, 116, 139, 0.08)'
              }
            }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleSubmit}
      variant="contained"
            sx={{
              backgroundColor: appColors.leaf,
              color: '#ffffff',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: appColors.pine
              }
            }}
    >
      {modalMode === "add" ? "Submit" : "Update"}
    </Button>
  </DialogActions>
</Dialog>

      <Dialog open={openDeleteConfirmation} onClose={handleCancelDelete}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this package?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<CancelIcon />}
            sx={{ fontWeight: "bold", textTransform: "none" }}
            onClick={handleCancelDelete}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            sx={{ fontWeight: "bold", textTransform: "none" }}
            variant="contained"
            startIcon={<DeleteIcon />}
            color="error"
          >
            {" "}
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
      <Dialog open={openConfirmation} onClose={handleCancel}>
        <DialogTitle>{isActive ? "Deactivate" : "Activate"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isActive
              ? "Are you sure you want to deactivate this item?"
              : "Are you sure you want to activate this item?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ fontWeight: "bold", textTransform: "none" }}
            startIcon={<CancelIcon />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            sx={{ fontWeight: "bold", textTransform: "none" }}
            variant="contained"
            startIcon={<CheckCircleIcon />}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default FollowUP;